import React from "react";
import { Modal, Form, Input, Button } from 'antd';

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const EditStateModalWithForm = ({visible, onCancel, data, handleOk}) => {
  return (
    <Modal
      title="Basic Modal"
      visible={visible}
      onCancel={onCancel}
      onOk={handleOk}
    >
      <Form
        {...layout}
        name="basic"
        initialValues={{
          name: data.name,
          biden: data.biden,
          trump: data.trump
        }}
        onFinish={handleOk}
      >
        <Form.Item
          label="State Name"
          name="name"
          rules={[
            {
              required: true,
              message: 'Please input your name!',
            },
          ]}
        >
          <Input />
        </Form.Item>
        
        <Form.Item
          label="Biden Value"
          name="biden"
          rules={[
            {
              required: true,
              message: 'Please input your biden value!',
            },
          ]}
        >
          <Input />
        </Form.Item>
        
        <Form.Item
          label="Trump Value"
          name="trump"
          rules={[
            {
              required: true,
              message: 'Please input your trump value!',
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item {...tailLayout}>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default EditStateModalWithForm;